module.exports = __webpack_public_path__ + "static/media/work-calendar.b04be949.png";